module.exports = __webpack_public_path__ + "static/media/live_default_image.bc0eda88.png";